<template>
    <div class="col-12 col-lg-9 row h-100 m-0 p-0 pr-lg-0" style="transition-delay: 0s;">
        <div class="scroll-panel col-12 col-lg-4 p-0 m-0 pl-lg-2 h-100">
            <Questionnaires ref="questionnaire" :user="user"></Questionnaires>
        </div>

        <div class="scroll-panel col-12 col-lg-4 p-0 m-0 pl-lg-2 h-100">
            <Questionnaires ref="vote" :user="user" :is_vote="1"></Questionnaires>
        </div>

        <div class="scroll-panel col-12 col-lg-4 p-0 m-0 pl-lg-4 h-100 section ">
            <Kudos title="Latest Kudos!" :user="user" limit="3"></Kudos>
        </div>
    </div>
</template>

<script>
import Kudos from "@/components/Kudos";
import Messages from "@/components/Messages";
import Questionnaires from "@/components/Questionnaires";

export default {
    name: 'Home',
    components: {
        Questionnaires,
        Kudos,
        Messages
    },
    props: [
        'user',
        'mood'
    ],
    data() {
        return {
            greeting: 'Hello',
            greetingExtra: ', how are feeling ?',
        };
    },
    methods: {},
    mounted() {
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue